import { Users, Phone, CheckCircle2, TrendingUp, Award, XCircle } from 'lucide-react';

export const StatsBar = ({ stats }) => {
  if (!stats) return null;

  const statItems = [
    { label: 'Total Leads', value: stats.total_leads, icon: Users, color: 'text-foreground' },
    { label: 'New', value: stats.new, icon: TrendingUp, color: 'text-slate-600 dark:text-slate-400' },
    { label: 'Contacted', value: stats.contacted, icon: Phone, color: 'text-blue-600 dark:text-blue-400' },
    { label: 'Qualified', value: stats.qualified, icon: CheckCircle2, color: 'text-amber-600 dark:text-amber-400' },
    { label: 'Won', value: stats.won, icon: Award, color: 'text-emerald-600 dark:text-emerald-400' },
    { label: 'Lost', value: stats.lost, icon: XCircle, color: 'text-red-600 dark:text-red-400' },
  ];

  return (
    <div className="border-b bg-muted/30 px-4 py-3" data-testid="stats-bar">
      <div className="flex items-center gap-6 overflow-x-auto">
        {statItems.map((item) => (
          <div key={item.label} className="flex items-center gap-2 min-w-fit">
            <item.icon className={`w-4 h-4 ${item.color}`} />
            <span className="text-xs text-muted-foreground">{item.label}</span>
            <span className="font-heading font-bold text-sm">{item.value}</span>
          </div>
        ))}
        <div className="flex items-center gap-2 min-w-fit ml-auto">
          <span className="text-xs text-muted-foreground">Total Follow-ups</span>
          <span className="font-heading font-bold text-sm text-accent">{stats.total_followups}</span>
        </div>
      </div>
    </div>
  );
};
